import React from "react";

const BrsrReportsCard = ({ cardTitle, count, value, selectedValue, onChange }) => {
  const isSelected = selectedValue === value;

  return (
    <div
      className={`flex items-center justify-start gap-3 p-4 h-24 rounded-lg cursor-pointer transition-all duration-200 ${
        isSelected
          ? "bg-white border-2 border-[#3bd6c6]"
          : "bg-[#F5F7F8] border border-[#d9d9d9]"
      }`}
      onClick={() => onChange(value)}
    >
      <div
        className={`w-8 h-8 font-bold text-xl flex items-center justify-center rounded-md ${
          isSelected ? "bg-[#3bd6c6] text-white" : "bg-[#d9d9d9] text-black"
        }`}
      >
        {count}
      </div>
      <p
        className={`font-semibold text-base ${
          isSelected ? "text-[#3bd6c6]" : "text-black"
        }`}
      >
        {cardTitle}
      </p>
    </div>
  );
};

export default BrsrReportsCard;
